<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="created" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="rateName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Channel Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.rateName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tokeet Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Date Mapped</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [matTooltip]="element.created | epoch" matTooltipPosition="above" matTooltipClass="text-center">
            {{ element.created | epoch: 'DD - MMM - YYYY' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a href="javascript:;" (click)="onDelete(element)"> <i class="fal fa-trash-alt"></i></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <ng-container *ngIf="isEmptyTable$ | async">
      <div class="empty-box">You haven't created any rate mapping yet</div>
    </ng-container>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="true"
      [pageSize]="100"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>
    <div class="my-3 text-center">
      <button (click)="onAdd()" type="button" class="btn btn-cst-primary text-uppercase">Add Rate Mapping</button>
    </div>
  </table>
</div>
